import axios from "axios";
import { defineStore } from "pinia";
import common from 'store/common'
import { messaging, getToken, onMessage } from '../firebase';

export const ChatsStore = defineStore('chats-store', {
  state: () => ({
    filterRoom: { limit: 15, page: 1, search: { text: '', tag: [], status: 'all' } },
    rooms: [],
    room: {},
    paginationRoom: { total: 0, currentPage: 1, perPage: 1, lastPage: 1 },

    filterMessages: { limit: 20, page: 1, search: '' },
    messages: [],
    message: { message: '', attachs: [], reply_to: null },
    intMessage: { message: '', attachs: [], reply_to: null },
    error: {},

    tags: [],
    customerTags: [],

    memos: [],
    memo: {},

    info: {},

    arrStatus: [
      { value: 'all', text: 'すべて' },
      { value: 'unread', text: '未読' },
      { value: 'action', text: '要対応' },
      { value: 'acknowledged', text: '対応済み' },
      { value: 'spam', text: 'スパム' },
    ],
    keyView: 0,
    mute: localStorage.getItem("chatMute") === 'true',
    showInfo: false
  }),
  getters: {
  },

  actions: {
    connectSocket() {
      if (!window.soketiEnable) {
        return;
      }
      const channel2 = window.Echo.private('TS.CHAT');
      const ringtone = new Audio('/audios/ringtone.mp3');

      channel2.listen('NewMessageEvent', (e) => {
        //add new or update room
        if (e.data.room) {
          e.data.room.updated_at = common.formartFullDate(e.data.room.updated_at)
          //update rooms, will move room update to top list          
          if (this.rooms[0].id === e.data.room.id) {
            this.rooms[0] = e.data.room
          }
          else {
            const findIdxRoom = this.rooms.findIndex(room => room.id === e.data.room.id)
            if (findIdxRoom) {
              this.rooms = this.rooms.filter(room => room.id !== e.data.room.id)
            }
            this.rooms.unshift(e.data.room);
          }

          //update room
          if (this.room.id === e.data.room.id) {
            this.room = e.data.room
          }
        }
        //add new message
        if (e.data.message && e.data.message.room_id == this.room.id) {
          const findIdxMsg = this.messages.findIndex(msg => msg.id === e.data.message.id)
          if (findIdxMsg < 0) {
            this.messages.push(e.data.message);
          }
        }

        // update realtime status
        if (e.data.status) {
          const findIdx = this.rooms.findIndex(room => room.id === e.data.status.id)
          if (findIdx >= 0) {
            this.rooms[findIdx].status = e.data.status.status
          }
        }

        //update realtime Memo
        if (e.data.memos && e.data.memos[0].customer_id == this.room.customer_id) {
          this.memos = e.data.memos
        }

        //update realtime Info customer
        if (e.data.info) {
          this.rooms.map(room => {
            if (room.customer_id == e.data.info.id) {
              room.name_fa = e.data.info.name_fa
            }
            return room
          })
          if (e.data.info.id == this.info.id) {
            this.info = e.data.info
          }
        }

        if (!e.data.message?.admin) {
          if (!this.mute) {
            ringtone.play().catch(error => {
              console.error('Playback failed:', error);
            });
          }
        }

        // this.keyView++
        //scroll to botton widget message
        setTimeout(() => {
          const chatMainMessages = document.getElementById('chat-main-messages');
          if (chatMainMessages) {
            chatMainMessages.lastElementChild.scrollIntoView({ behavior: 'smooth' });
          }
        }, 200)

      });

    },

    disconnectSocket() {
      if (!window.soketiEnable) {
        return;
      }
      const channel2 = window.Echo.private('TS.CHAT');
      channel2.stopListening('NewMessageEvent');
    },

    async getRooms() {
      const response = await axios.post(`/api/get-roooms`, this.filterRoom)
      const arrRoom = response.data.data.map(room => {
        room.updated_at = common.formartFullDate(room.updated_at)
        return room
      })
      if (this.filterRoom.page == 1) {
        this.rooms = arrRoom
      }
      else {
        this.rooms.push(...arrRoom)
      }

      this.paginationRoom.total = response.data.total
      this.paginationRoom.currentPage = response.data.current_page
      this.paginationRoom.perPage = response.data.per_page
      this.paginationRoom.lastPage = response.data.last_page

      this.keyView++

    },

    async getMessages($room_id) {
      this.filterMessages.room_id = $room_id
      const response = await axios.post(`/api/messages`, this.filterMessages)
      this.messages = response.data
    },
    async saveMessage() {
      this.message.room_id = this.room.id
      this.message.receiver_id = this.room.customer_id

      const response = await axios.post('/api/message/save', this.message)
      return response.data
    },

    async getCustomerInfo($customer_id, $room_id) {
      const response = await axios.post(`/api/customer`, { customer_id: $customer_id, room_id: $room_id })
      if (response.data.tags) {
        this.tags = response.data.tags
      }
      if (response.data.customerTags) {
        this.customerTags = response.data.customerTags
      }

      if (response.data.memos) {
        this.memos = response.data.memos
      }

      if (response.data.info) {
        this.info = response.data.info
      }
    },
    async saveCustomerTag(tags) {
      const response = await axios.post(`/api/customer-tags/save`, { customer_id: this.room.customer_id, tags: tags, room_id: this.room.id });
      return response.data ?? []
    },

    async saveCustomerMemo() {
      const response = await axios.post(`/api/customer-memo/save`, this.memo);

      if (response.data.memos) {
        this.memos = response.data.memos
      }
      return response.data
    },

    async updateMemoSort() {
      const response = await axios.post('/api/customer-memo/update-sort', { memos: this.memos, customer_id: this.room.customer_id })
      if (response.data.memos) {
        this.memos = response.data.memos
      }
      return response.data
    },

    async deleteCustomerMemo() {
      const response = await axios.post('/api/customer-memo/delete', { id: this.memo.id, customer_id: this.memo.customer_id })
      if (response.data.memos) {
        this.memos = response.data.memos
      }
      return response.data
    },

    async saveCustomerInfo() {
      const response = await axios.post(`/api/customer-info/save`, this.info);

      if (response.data.info) {
        this.info = response.data.info
      }
      return response.data
    },

    toggleMute() {
      this.mute = !this.mute;
      localStorage.setItem("chatMute", this.mute);
    },

    async changeRoom(idx) {
      if (this.rooms[idx].readed == false) {
        this.rooms[idx].readed = true
      }

      this.room = this.rooms[idx];

      await this.getMessages(this.room.id);

      await this.getCustomerInfo(this.room.customer_id, this.room.id);

      setTimeout(() => {
        document.getElementById('chat-main-messages').lastElementChild.scrollIntoView({ behavior: 'smooth' });
      }, 500)
    },

    async requestNotificationPermission() {
      try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          const token = await getToken(messaging, {
            vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY
          });
          await this.saveDeviceToken(token);
          this.listenForMessages();
          return token;
        }
      } catch (error) {
        console.error('Error getting FCM token:', error);
      }
    },

    async saveDeviceToken(token) {
      try {
        await axios.post('/api/device-token/save', { token });
      } catch (error) {
        console.error('Error saving device token:', error);
      }
    },

    listenForMessages() {
      onMessage(messaging, (payload) => {
        console.log('Foreground message:', payload);
        // Handle foreground notification click
        // if (payload.data?.room_id) {
        //   this.openRoomById(parseInt(payload.data.room_id));
        // }
      });
    },

    async openRoomById(roomId) {
      // Find room in current rooms list
      const roomIdx = this.rooms.findIndex(room => room.id === roomId);

      if (roomIdx >= 0) {
        // Room found in current list, open it
        await this.changeRoom(roomIdx);
      } else {
        // Room not in current list, fetch it
        const response = await axios.post(`/api/get-room-by-id`, { room_id: roomId });
        if (response.data) {
          response.data.updated_at = common.formartFullDate(response.data.updated_at);
          this.room = response.data;

          // Add to rooms list if not exists
          const existingIdx = this.rooms.findIndex(r => r.id === roomId);
          if (existingIdx < 0) {
            this.rooms.unshift(response.data);
          }

          await this.getMessages(this.room.id);
          await this.getCustomerInfo(this.room.customer_id, this.room.id);

          setTimeout(() => {
            const chatMainMessages = document.getElementById('chat-main-messages');
            if (chatMainMessages) {
              chatMainMessages.lastElementChild.scrollIntoView({ behavior: 'smooth' });
            }
          }, 200);
        }
      }
    },

    checkNotificationUrl() {
      // Check if URL has room_id parameter (from notification click)
      const urlParams = new URLSearchParams(window.location.search);
      const roomId = urlParams.get('room_id');

      if (roomId) {
        console.log('Opening room from notification:', roomId);
        this.openRoomById(parseInt(roomId));
        // Clean up URL
        window.history.replaceState({}, document.title, window.location.pathname);
      } else {
        console.log('No room_id in URL');
      }
    },

    async checkAndSaveDeviceToken() {
      try {
        // Check if notifications are supported
        if (!('Notification' in window)) {
          console.log('This browser does not support notifications');
          return;
        }

        // Check if permission is already granted
        if (Notification.permission === 'granted') {
          const token = await getToken(messaging, {
            vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY
          });

          if (token) {
            await this.saveDeviceToken(token);
            this.listenForMessages();
            console.log('Device token saved successfully');
          }
        } else {
          console.log('Notification permission not granted yet');
        }
      } catch (error) {
        console.error('Error checking and saving device token:', error);
      }
    }
  }
});